/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description tagsFollowsUsingGet参数
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamstagsFollowsUsingGet {
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description tagsTagIdFollowUsingPost参数
 * @property `tagId` 标签id
 * @property `follow` 是否关注，true为关注，false为取关
 */
export interface ParamstagsTagIdFollowUsingPost {
  // pathParams
  /**
   * 标签id
   */
  tagId: number;
  // queryParams
  /**
   * 是否关注，true为关注，false为取关
   */
  follow: boolean;
}
/**
 * @description tagsTagIdHotUsingGet参数
 * @property `tagId` 标签id
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamstagsTagIdHotUsingGet {
  // pathParams
  /**
   * 标签id
   */
  tagId: number;
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description tagsTagIdLastUsingGet参数
 * @property `tagId` 标签id
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 * @property `type` 类型：1文章 2提问 3回答
 */
export interface ParamstagsTagIdLastUsingGet {
  // pathParams
  /**
   * 标签id
   */
  tagId: number;
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
  /**
   * 类型：1文章 2提问 3回答
   */
  type: number;
}
/**
 * @description tagsTagIdUsingGet参数
 * @property `tagId` 标签的id
 */
export interface ParamstagsTagIdUsingGet {
  // pathParams
  /**
   * 标签的id
   */
  tagId: number;
}
/**
 * @description tagsUsingPost参数
 * @property `[profile]` 标签简介
 * @property `tagName` 标签名称
 */
export interface ParamstagsUsingPost {
  // queryParams
  /**
   * 标签简介
   */
  profile?: string;
  /**
   * 标签名称
   */
  tagName: string;
}
export class TagApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 分页获取关注的所有标签
   * @param params ParamstagsFollowsUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public tagsFollowsUsingGet = (
    params: ParamstagsFollowsUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/tags/follows';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 根据id关注或取关标签
   * @param params ParamstagsTagIdFollowUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public tagsTagIdFollowUsingPost = (
    params: ParamstagsTagIdFollowUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/tags/{tagId}/follow';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('follow' in params) p.query.follow = params.follow;
    ajax.check(params.follow, 'follow');
    ajax.check(params.tagId, 'tagId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 分页获取标签热门文章
   * @param params ParamstagsTagIdHotUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public tagsTagIdHotUsingGet = (
    params: ParamstagsTagIdHotUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/tags/{tagId}/hot';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    ajax.check(params.tagId, 'tagId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 分页获取标签最新文章/提问/回答
   * @param params ParamstagsTagIdLastUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResult
   */
  public tagsTagIdLastUsingGet = (
    params: ParamstagsTagIdLastUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResult> => {
    const path = '/api/tags/{tagId}/last';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.type, 'type');
    ajax.check(params.tagId, 'tagId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 根据id查询标签详情
   * @param params ParamstagsTagIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public tagsTagIdUsingGet = (
    params: ParamstagsTagIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/tags/{tagId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.tagId, 'tagId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 新增标签
   * @param params ParamstagsUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public tagsUsingPost = (
    params: ParamstagsUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/tags';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('profile' in params) p.query.profile = params.profile;
    if ('tagName' in params) p.query.tagName = params.tagName;
    ajax.check(params.tagName, 'tagName');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new TagApi();
